<template>
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 149.978 60.104" enable-background="new 0 0 149.978 60.104" xml:space="preserve">
    <rect x="45.995" y="16.229"  width="9.156" height="32.322"/>
    <g>
        <defs>
            <rect id="SVGID_1_" y="0" width="149.978" height="60.104"/>
        </defs>
        <clipPath id="SVGID_2_">
            <use xlink:href="#SVGID_1_"  overflow="visible"/>
        </clipPath>
        <path clip-path="url(#SVGID_2_)"  d="M89.115,44.495c0,5.284-1.342,9.207-4.025,11.768
            c-2.683,2.56-6.83,3.841-12.443,3.841c-1.966,0-3.932-0.175-5.898-0.522c-1.967-0.349-3.79-0.81-5.47-1.383l1.598-7.682
            c1.434,0.574,2.939,1.024,4.517,1.353c1.576,0.327,3.369,0.491,5.377,0.491c2.621,0,4.475-0.574,5.561-1.721
            c1.085-1.147,1.628-2.62,1.628-4.424v-1.167c-0.982,0.451-1.997,0.789-3.042,1.014c-1.044,0.225-2.181,0.338-3.41,0.338
            c-4.465,0-7.887-1.321-10.262-3.964c-2.376-2.642-3.564-6.339-3.564-11.092c0-2.375,0.368-4.536,1.106-6.483
            c0.737-1.946,1.813-3.615,3.226-5.008c1.413-1.392,3.143-2.467,5.193-3.226c2.047-0.758,4.362-1.137,6.943-1.137
            c1.105,0,2.243,0.052,3.411,0.154c1.167,0.102,2.324,0.236,3.472,0.399c1.146,0.164,2.242,0.359,3.287,0.584
            c1.045,0.226,1.976,0.461,2.796,0.707V44.495z M69.021,31.345c0,5.122,2.068,7.681,6.207,7.681c0.94,0,1.822-0.122,2.642-0.369
            c0.819-0.244,1.516-0.531,2.089-0.859V23.172c-0.451-0.082-0.982-0.153-1.598-0.215c-0.614-0.061-1.331-0.091-2.15-0.091
            c-2.417,0-4.22,0.798-5.408,2.396C69.614,26.86,69.021,28.887,69.021,31.345"/>
        <path clip-path="url(#SVGID_2_)"  d="M95.181,48.551V2.341l9.156-1.475v15.485c0.615-0.204,1.403-0.399,2.365-0.583
            c0.963-0.185,1.895-0.277,2.797-0.277c2.621,0,4.803,0.359,6.544,1.076c1.742,0.717,3.134,1.731,4.179,3.041
            c1.045,1.312,1.781,2.868,2.213,4.671c0.431,1.803,0.645,3.809,0.645,6.022v18.25h-9.156V31.406c0-2.949-0.379-5.04-1.137-6.268
            c-0.757-1.229-2.161-1.844-4.209-1.844c-0.82,0-1.587,0.072-2.305,0.215c-0.717,0.145-1.362,0.298-1.936,0.461v24.58H95.181z"/>
        <path clip-path="url(#SVGID_2_)"  d="M128.531,8.178l9.156-1.475v9.525h10.999v7.619h-10.999v11.37
            c0,1.926,0.338,3.461,1.014,4.607c0.677,1.148,2.037,1.721,4.087,1.721c0.982,0,1.997-0.092,3.041-0.275
            c1.045-0.186,1.997-0.44,2.857-0.769l1.291,7.128c-1.106,0.451-2.335,0.84-3.688,1.168c-1.352,0.327-3.011,0.491-4.978,0.491
            c-2.499,0-4.568-0.338-6.206-1.014c-1.638-0.677-2.949-1.618-3.932-2.827c-0.984-1.207-1.67-2.673-2.06-4.395
            c-0.39-1.719-0.584-3.625-0.584-5.713V8.178z"/>
        <path clip-path="url(#SVGID_2_)"  d="M55.726,6.396c0-2.776-2.25-5.027-5.027-5.027
            c-2.776,0-5.026,2.251-5.026,5.027s2.25,5.026,5.026,5.026C53.476,11.421,55.726,9.171,55.726,6.396"/>
        <path clip-path="url(#SVGID_2_)"  d="M9.78,0c0,0-6.072,2.521-1.986,7.411c4.086,4.888,7.539,7.533,14.843,11.922
            c7.304,4.388,14.209,9.974,16.717,15.861c2.507,5.889-0.314,9.223-1.768,10.907c-1.453,1.686-2.583,2.449-2.583,2.449
            s0.846-1.433-2.197-5.034c-3.044-3.603-3.809-5.555-17.917-13.398C8.918,26.799,2.146,20.715,0.62,16.631
            c-1.49-3.989,0.003-8.061,1.376-10.597C3.37,3.498,7.515,0.4,9.78,0"/>
        <path clip-path="url(#SVGID_2_)"  d="M35.726,6.396c0-2.776-2.25-5.027-5.027-5.027
            c-2.776,0-5.026,2.251-5.026,5.027s2.25,5.026,5.026,5.026C33.476,11.421,35.726,9.171,35.726,6.396"/>
        <path clip-path="url(#SVGID_2_)"  d="M12.062,43.319c0-2.832-2.296-5.128-5.127-5.128
            c-2.832,0-5.128,2.296-5.128,5.128s2.296,5.127,5.128,5.127C9.766,48.446,12.062,46.151,12.062,43.319"/>
    </g>
    </svg>
</template>

<script>
export default {
    name: 'LogoSight',
}
</script>

<style lang="scss" scoped>
</style>